import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, "選択中の生徒に実行", -1)
const _hoisted_3 = { class: "w-full max-h-48 py-2 text-gray-700 text-sm font-medium bg-white shadow-lg rounded overflow-y-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_m_button, {
      color: "primary-500",
      "hover-color": "primary-600",
      disabled: _ctx.disabled,
      onClick: _ctx.changeShowModal
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        (_ctx.showModal)
          ? (_openBlock(), _createBlock(_component_m_icon, {
              key: 0,
              type: "chevron-up",
              class: "ml-2"
            }))
          : (_openBlock(), _createBlock(_component_m_icon, {
              key: 1,
              type: "chevron-down",
              class: "ml-2"
            }))
      ]),
      _: 1
    }, 8, ["disabled", "onClick"]),
    _createVNode("div", {
      class: ["absolute left-0 pt-4 pb-4 z-10", { hidden: !_ctx.showModal }]
    }, [
      _createVNode("div", _hoisted_3, [
        (_ctx.useManagement)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              class: "w-full px-2 py-2 text-left border-b hover:bg-gray-100",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setAllFulfilled && _ctx.setAllFulfilled(...args)))
            }, " 確認済にする "))
          : _createCommentVNode("", true),
        (!_ctx.isAdmin)
          ? (_openBlock(), _createBlock("button", {
              key: 1,
              class: "w-full px-2 py-2 text-left border-b hover:bg-gray-100",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openAll && _ctx.openAll(...args)))
            }, " 提出物を閲覧する "))
          : _createCommentVNode("", true),
        _createVNode("button", {
          class: "w-full px-2 py-2 text-left hover:bg-gray-100",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.message && _ctx.message(...args)))
        }, " 一斉メッセージ ")
      ])
    ], 2)
  ]))
}